<template>
  <div class="container">
    <UploadMedia @isUploadSuccessful="getUploadSuccessEvent"></UploadMedia>
    <div class="row">
      <div class="col-lg-12 col-md-12 col-sm-12">
        <div style="background-color: rgb(255, 255, 255);border-radius: 1rem;padding: 6px;">
          <div class="row">
          </div>
          <div class="row">
            <div v-for="(info, index) in mediaArray" :key="index" class="col-lg-2 col-md-4 col-sm-6">
              <div>
                <template v-if="info.media_file_type == 'image'">
                  <img
                      :class="{ 'selected-image': info.media_file_id == selectedImgId
                      || info.showFilePath == selectedImgPath }"
                      :src="info.showFilePath" alt="media" class="img-thumbnail"
                      style="display:flex; height: 100px;width: 100px;justify-content: center;
                      align-items: center; padding: 8px;margin: 8px;"
                      @click="selectImage(info)" @error="handleImageError">
                </template>

                <template v-else-if="info.media_file_type === 'video'">
                  <video controls height="100%" width="100%">
                    <source :src="info.showFilePath" type="video/mp4">
                    Your browser does not support the video tag.
                  </video>
                </template>

                <template v-else-if="info.media_file_type === 'audio'">
                  <audio controls>
                    <source :src="info.showFilePath" type="audio/mpeg">
                    Your browser does not support the audio element.
                  </audio>
                </template>

                <template v-else-if="info.media_file_type === 'pdf'">
                  <div :class="{ 'selected-image': info.media_file_id == selectedImgId }" class="border rounded"
                       style="text-align: center;height: 100px;width: 100px; padding: 8px; border: 1px solid gray;margin: 8px;">
                    <img alt="" src="@/assets/img/pdf_icon.svg"
                         style="height: 40px; width: 40px; background-color: white;">
                    <div class="titleText" style="overflow: hidden; word-wrap: break-word; ">
                      {{ info.media_file_name }}
                    </div>
                  </div>
                </template>
                <!--                    others-->
                <template v-else>
                  <div
                      class="border rounded"
                      style="text-align: center;height: 100px;width: 100px; padding: 8px;margin: 8PX; border: 1px solid gray;">
                    <img alt="" src="@/assets/unknown.png" style="height: 40px; width: 40px;">
                    <div class="titleText" style="overflow: hidden; word-wrap: break-word; ">
                      {{ info.media_file_name }}
                    </div>
                  </div>
                </template>

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MediaService from "@/services/media.service";
import Config from "@/config/index.js";
import UploadMedia from '@/components/Media/UploadMedia.vue';

export default {
  name: 'selectLogo',
  components: {
    UploadMedia,
  },
  data() {
    return {
      selectedImgId: null,
      selectedImgPath: '',
      selectedImageIndex: null,
      mediaArray: [],
      editMedia: false,
      media: {
        media_file_id: '',
        media_file_type: '',
        media_file_name: '',
        file_path: '',
        insert_by: '',
        insert_date: '',
      },
    };
  },
  props: ['fetchId', 'fetchPath'],
  mounted() {
    this.selectedImgId = this.fetchId;
    this.selectedImgPath = this.fetchPath;
    this.fetchMedia();
  },
  methods: {
    async getUploadSuccessEvent(data) {
      if (data == true) {
        await this.fetchMedia();
      }
    },

    reset() {
      this.selectedImgId = null;
      this.editMedia = false;
      this.media = null;
    },
    selectImage(info) {
      this.selectedImgId = null;
      this.selectedImgPath = null;
      this.selectedImgId = info.media_file_id;
      this.editMedia = true;
      this.media = info;
      this.$emit('logoImg', info);
    },

    async fetchMedia() {
      this.mediaArray = [];
      this.editMedia = false;
      this.media = {
        media_file_id: '',
        media_file_type: '',
        media_file_name: '',
        file_path: '',
        insert_by: '',
        insert_date: '',
      };
      await MediaService.getAllMedia()
          .then(response => {
            this.mediaArray = response.data;
            //iterate through the array and add the file path
            this.mediaArray.forEach(element => {
              // element.file_path = Config.apiFileBasePath + element.file_path;
              element.showFilePath = Config.apiFileBasePath + '/thumbnail' + element.thumbnail_file_path;
            });

          })
          .catch(e => {
            console.log(e);
          });
    },
    handleImageError(event) {
      // Update the image source to the dummy image when an error occurs
      event.target.src = "https://demofree.sirv.com/nope-not-here.jpg";
    },

  }
}

</script>

<style scoped>
.selected-image {
  border: 5px solid #007bff;
  /* background-color: #007bff; */
}

.titleText {
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  /* number of lines to show */
  line-clamp: 2;
  -webkit-box-orient: vertical;
  text-overflow: ellipsis;
}
</style>
